export function GetStrategies(category) {
	switch (category) {
		case "paving":
			return ["sqm", "single"];
		case "kerbs":
			return ["single"];
		case "retaining-walls":
			return ["single"];
		case "special":
			return ["single"];
		case "sand":
			return ["single"];
		case "cement":
			return ["single"];
	}
}
